<template>
  <select ref="slProveedores" id="" class="form-control">
    <option value="-1">Seleccione un proveedor</option>
    <option :value="proveedor._id" v-for="proveedor in proveedores" :key="proveedor._id">{{proveedor.razonSocial}}</option>
  </select>
</template>
<script>
  import $ from 'jquery'
  import './../../assets/css/select2.css'
  import 'select2'
  import _ from 'lodash'
  export default {
    props: {
      value: {
        type: String,
        default: () => null
      }
    },
    data () {
      return {
        proveedores: []
      }
    },
    mounted () {
      const me = this
      me.$http.get('/api/admin/proveedores').then(({body}) => {
        me.proveedores = _.sortBy(body.proveedores, 'razonSocial')
      }, (err) => {
        console.error(err)
      }).then(() => {
        $(me.$refs.slProveedores).select2({
          placeholder: 'Seleccione un proveedor'
        }).on('change', () => {
          console.log('Proveedor', me.$refs.slProveedores.value)
          me.$emit('input', me.$refs.slProveedores.value)
          me.$emit('change-proveedor', me.$refs.slProveedores.value)
        })
      })
    }
  }
</script>



// WEBPACK FOOTER //
// ComboProveedores.vue?d5296a88